<template>
  <v-layout row pa-3>
    <v-flex xs12 sm12>
      <v-alert :value="noData" dismissible color="error" icon="warning" outlined
        >We can't find an order. Please use an order ID or number.</v-alert
      >
      <v-card>
        <v-toolbar text>
          <v-icon>list_alt</v-icon>
          <v-toolbar-title>Orders</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-flex xs6>
            <v-container pa-0>
              <v-layout align-center row>
                Number per pages:
                <v-flex xs1 pa-2>
                  <v-select
                    :items="pageStepChoices"
                    v-model="pageStep"
                  ></v-select>
                </v-flex>
                <v-text-field
                  v-model="searchQuery"
                  v-on:keyup.enter="search(searchQuery)"
                ></v-text-field>
                <v-btn icon @click.stop="search(searchQuery)">
                  <v-icon>search</v-icon>
                </v-btn>
              </v-layout>
            </v-container>
          </v-flex>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="items"
          class="mt-1"
          hide-default-footer
          :loading="loading"
        >
          <template v-slot:item="props">
            <tr>
              <td>
                <a @click.stop="viewItem(props.item)">{{ props.item.id }}</a>
              </td>
              <td>{{ props.item.order_number }}</td>
              <td>{{ props.item.title }}</td>
              <td>
                <span class="grey--text">User:</span>&nbsp;
                <a @click.stop="viewProfile(props.item.user_id)">{{
                  props.item.user_id
                }}</a>
                <br />
                <span class="grey--text">Operator:</span>
                &nbsp;
                {{ operatorName(props.item) }}
              </td>
              <td>{{ props.item.created | moment("YYYY-DD-MM HH:mm") }}</td>
              <td>
                <span
                  v-if="props.item.status === 'ongoing'"
                  class="blue--text font-weight-medium"
                  >Ongoing</span
                >
                <span
                  v-else-if="props.item.status === 'opened'"
                  class="grey--text font-weight-medium"
                  >Opened</span
                >
                <span
                  v-else-if="props.item.status === 'reopened'"
                  class="orange--text font-weight-medium"
                  >Reopened</span
                >
                <span
                  v-else-if="props.item.status === 'resolved'"
                  class="orange--text font-weight-medium"
                  >Resolved</span
                >
                <span
                  v-else-if="props.item.status === 'rejected'"
                  class="red--text font-weight-medium"
                  >Rejected</span
                >
                <span
                  v-else-if="props.item.status === 'closed'"
                  class="green--text font-weight-medium"
                  >Closed</span
                >
                <span v-else>{{ props.item.status }}</span>
              </td>
              <td>
                <v-btn icon @click.stop="viewItem(props.item)">
                  <v-icon class="mr-2">visibility</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>No data</template>
        </v-data-table>
        <v-footer>
          <v-btn text @click.stop="previousItems()">Previous</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click.stop="nextItems()">Next</v-btn>
        </v-footer>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import fb from "@/firebase";
import { mapState, mapMutations } from "vuex";

import OrderInfo from "@/components/OrderInfo";

import ProfileView from "@/views/ProfileView";

const orders = fb.db
  .collection("user_orders")
  .orderBy("created", "desc")
  .limit(10);

export default {
  components: {},
  data: () => ({
    items: [],
    lastVisible: "",
    searchQuery: "",
    noData: false,
    itemFound: {},
    pageStepChoices: [10, 20, 50, 100, 200],
    pageStep: 10,
    headers: [
      { text: "ID", value: "id", sortable: false },
      { text: "Number", value: "number", sortable: false },
      { text: "Title", value: "title", sortable: false },
      { text: "Infos", value: "infos", sortable: false },
      { text: "Created", value: "created", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Actions", value: "name", sortable: false, align: "center" }
    ],
    modal: {
      name: "OrderInfo",
      payload: {}
    },
    loading: false
  }),
  computed: {
    ...mapState(["operators"])
  },
  firestore: {
    items: orders
  },
  watch: {
    pageStep: function() {
      this.$bind(
        "items",
        fb.db
          .collection("user_orders")
          .orderBy("created", "desc")
          .limit(this.pageStep)
      );
    },
    items(val) {
      if (val.length > 0 && val.length <= this.pageStep) {
        this.lastVisible = val[val.length - 1].created;
      }
    }
  },
  methods: {
    ...mapMutations(["setAppAlert"]),
    viewProfile(profileId) {
      fb.db
        .collection("user_profiles")
        .doc(profileId)
        .get()
        .then(profile => {
          this.$modal.show(
            ProfileView,
            {
              profile: profile.data()
            },
            {
              height: "auto",
              width: "90%",
              minWidth: 500,
              maxWidth: 900,
              scrollable: true
            }
          );
        });
    },
    viewItem: function(item) {
      this.$modal.show(
        OrderInfo,
        {
          order: item
        },
        {
          height: "auto",
          width: "70%",
          minWidth: 500,
          maxWidth: 900,
          scrollable: true
        }
      );
    },
    nextItems: function() {
      this.$bind(
        "items",
        fb.db
          .collection("user_orders")
          .orderBy("created", "desc")
          .limit(this.pageStep)
          .startAt(this.lastVisible)
      );
    },
    previousItems: function() {
      this.$bind(
        "items",
        fb.db
          .collection("user_orders")
          .orderBy("created", "desc")
          .limit(this.pageStep)
          .endAt(this.lastVisible)
      );
    },
    search: function(query) {
      this.noData = false;
      let ref = fb.db.collection("user_orders");
      if (query && query.length >= 5) {
        if (/^\d+$/.test(query)) {
          ref
            .where("order_number", "==", Number(query))
            .get()
            .then(snapshot => {
              if (snapshot.empty) {
                this.noData = true;
              } else {
                snapshot.forEach(doc => {
                  this.itemFound = doc.data();
                  this.itemFound.id = doc.id;
                });
                this.items = [this.itemFound];
              }
            })
            .catch(() => {
              this.noData = true;
            });
        } else {
          ref = ref
            .doc(query)
            .get()
            .then(doc => {
              if (doc.data()) {
                this.itemFound = doc.data();
                this.itemFound.id = doc.id;
                this.items = [this.itemFound];
              } else {
                this.noData = true;
              }
            })
            .catch(() => {
              this.noData = true;
            });
        }
      } else {
        this.$bind("items", orders);
      }
    },
    operatorName: function(item) {
      if (item.operator_id) {
        let operator = this.operators.find(function(element) {
          return element.id === item.operator_id;
        });
        if (operator !== undefined && operator.name) {
          return operator.name;
        }
        return item.operator_id;
      }
    }
  }
};
</script>
